import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Governorate } from '../interfaces/governorate';

@Injectable({
  providedIn: 'root'
})
export class GovernoratesService {
  private apiUrl = environment.Server_URL + '/governorates';
  private governoratePricesUrl = environment.Server_URL + '/governorate-prices'; // 🆕

  constructor(private http: HttpClient) {}

  // 🟢 Get all governorates
  getAllGovernorates(): Observable<Governorate[]> {
    return this.http.get<Governorate[]>(this.apiUrl);
  }

  // 🟢 Get cities of a governorate
  getCitiesByGovernorate(governorateId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${governorateId}/cities`);
  }
  getCity(id:any):Observable<any>{
    return this.http.get(environment.Server_URL+`/governorates/${id}/cities`);
  }
  // =============================
  // 🆕 Governorate Prices Methods
  // =============================

  // 🟢 Get all governorate prices
  getAllGovernoratePrices(): Observable<any[]> {
    return this.http.get<any[]>(this.governoratePricesUrl);
  }

  // 🟢 Create new price
  createGovernoratePrice(data: { governorate_id: number; price: number }): Observable<any> {
    return this.http.post<any>(this.governoratePricesUrl, data);
  }

  // 🟢 Update price
  updateGovernoratePrice(id: number, data: { governorate_id: number; price: number }): Observable<any> {
    return this.http.put<any>(`${this.governoratePricesUrl}/${id}`, data);
  }

  // 🟢 Delete price
  deleteGovernoratePrice(id: number): Observable<any> {
    return this.http.delete<any>(`${this.governoratePricesUrl}/${id}`);
  }
}
